<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.jornada"
        ref="DataTable"
        sort-by="nome"
    >

        <template v-slot:cell(cpf)="row">
            {{ row.value | formatCpf }}
        </template>

        <template v-slot:cell(actions)="{ item }">

            <rkm-button
                @click.stop="$router.push({ name: 'exame-imagem-jornada-create', params: { id: item.id } })"
                color="primary"
                title="Visualizar"
                small
            >
                <rkm-icon icon="search" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    created() {

        this.repositories = {
            jornada: this.getConectaSusRepository('exameImagem.jornada'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao'),
        }
    },
    data: () => ({
        fields: [
            {
                key: 'nome',
                label: 'Nome',
                name: 'cadastro_cidadao.nome',
                searchable: true,
                sortable: true,
            },
            {
                key: 'dataNascimento',
                label: 'Data nascimento',
                name: 'cadastro_cidadao.dataNascimento',
                searchable: true,
                sortable: true,
            },
            {
                key: 'cpf',
                label: 'CPF',
                name: 'cadastro_cidadao.cpf',
                searchable: true,
                sortable: true,
            },
             {
                key: 'ocupacaoNome',
                label: 'CBO',
                name: 'ocupacao.nome',
                searchable: true,
                sortable: true,
            },
            {
                class: 'col-min',
                key: 'actions',
                label: 'Ações',
                name: 'actions',
            },
        ],
        repositories: {
            usuario: null,
        },
    }),
    filters: {
        formatCpf: formats.formatCpf,
    },
    mixins: [ repository, error ],
}
</script>

<style scoped>
.danger {
    color: var(--danger);
}
</style>